import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { IApiPagination } from "../../../interfaces/IPagination";
import {
  GetUsersResponse,
  TUserFilter,
  UserInterface,
} from "../../../interfaces/userInterface";
import axiosTeethTab from "../../../services/apiCall";

type UserApiInterface = {
  getUsers: (
    filter: TUserFilter,
    pagination: IApiPagination,
  ) => Promise<ApiResponse<GetUsersResponse>>;
  saveUser: (user: UserInterface) => Promise<ApiResponse<UserInterface>>;
  getUserById: (id: string) => Promise<ApiResponse<UserInterface>>;
  enable: (id: string) => Promise<ApiResponse<UserInterface>>;
  disable: (id: string) => Promise<ApiResponse<UserInterface>>;
};

export const userApi: UserApiInterface = {
  getUsers: async (filter, pagination) => {
    return await axiosTeethTab.get("users/filter", {
      params: { filter, pagination },
    });
  },
  saveUser: async (user) => {
    const endpoint = user._id ? `users/${user._id}` : "users";
    return await axiosTeethTab.post<UserInterface>(endpoint, user);
  },
  getUserById: async (id: string) => {
    return await axiosTeethTab.get<UserInterface>(`users/${id}`);
  },
  enable: async (id: string) => {
    return await axiosTeethTab.patch<UserInterface>(`users/${id}/enable`);
  },
  disable: async (id: string) => {
    return await axiosTeethTab.patch<UserInterface>(`users/${id}/disable`);
  },
};
